import { AppState } from "@/store/root.reducer";
import React, { ChangeEvent } from "react"
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { GetGalleries } from "../store/admin.actions";
import { Gallery } from "@/types/galleryData";
import './files.scss';
import { GalleryFileConfirmModal } from "../../../components/modals/galleryfile-confirm.modal";
import { ToastContainer, toast } from "react-toastify";

const GALLERY_TYPES = ['mom', 'sellermom', 'procedural'];

export const GalleryFiles = () => {
    const successNotify = (msg: any) => {
        toast.success(msg, {
          position: "bottom-left",
        })
      }
    
      const failedNotify = (msg: string) => {
        toast.error(msg, {
          position: "bottom-left",
        })
      }

    const dispatch = useDispatch();

    React.useEffect(() => {
        (async () => {
            dispatch(GetGalleries());
        })();
    }, [])

    const galleries: Gallery[] = useSelector((state: AppState) => state.admin.galleries);
    
    const [ hdriFile, setHdriFile ] = React.useState<File>();

    // options 
    const [ batch, setBatch ] = React.useState<boolean>(false);
    const [ galleryType, setGalleryType ] = React.useState<string>("");
    const [ selectedGallery, setSelectedGallery ] = React.useState<Gallery>();

    const [ confirmModal, setConfirmModal ] = React.useState<boolean>(false);

    const onFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        setHdriFile(e.target.files[0]);
    }

    const onChangeGalleryType = (e: ChangeEvent<HTMLInputElement>, type: string) => {
        let newTypes = "";
        const types = galleryType.split(",");
        if (e.target.checked) {
            // add to types 
            types.push(type);
            newTypes = types.filter(t => t !== "").join()
        } else {
            newTypes = types.filter(t => t !== "" && t !== type).join()
        }
        setGalleryType(newTypes);
    }

    const onUpdate = () => {
        if (!hdriFile) {
            failedNotify("Hdri file is not selected")
            return;
        }

        if (batch) {
            if (galleryType === "") {
                // error
                failedNotify("Gallery type is missing")
                return;
            }
        } else {
            if (!selectedGallery) {
                // error
                failedNotify("Gallery is not selected")
                return;
            }
        }

        setConfirmModal(true);
    }

    const onSubmitted = (status: boolean) => {
        if (status) {
            successNotify("Successfully updated.");
        } else {
            failedNotify("Failed to update.")
        }
    }
    
    return (
        <div className="container mb-4">
            <div className="mt-5">
                <button className="btn-custom small" onClick={onUpdate}>Update</button>
            </div>
            <div className="mt-3">
                <label htmlFor="galleryfile">Select Gallery HDRI</label>
                <input 
                    id="galleryfile" 
                    type="file" 
                    onChange={onFileChange} 
                    className="form-control w-50 mt-3"
                />
            </div>
            <div className="mt-4">
                <input 
                    className="me-1"
                    id="batch_update" 
                    type="checkbox" 
                    onChange={e => setBatch(e.target.checked)}
                />
                <label htmlFor="batch_update">Batch Update</label>
            </div>
            {batch && <div className="mt-3">
                Select gallery type to update
                <div className="mt-1">
                    {GALLERY_TYPES.map(g => {
                        return (
                            <div className="mt-1" key={g}>
                                <input 
                                    id={g}
                                    className="me-1"
                                    type="checkbox"
                                    onChange={e => onChangeGalleryType(e, g)}
                                />
                                <label htmlFor={g}>{g.toUpperCase()}</label>
                            </div>
                        )
                    })}
                </div>
            </div>}
            {!batch && <div className="w-75 mt-4">
                <div>Select one of gallery: &nbsp;&nbsp;
                    {selectedGallery && <>
                        <span className="fs-5">{selectedGallery.name}&nbsp;</span>
                    </>}
                </div>
                <table className="table table-striped mt-3">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Space Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {galleries.map(g => {
                            return <tr 
                                key={g._id}
                                onClick={() => setSelectedGallery(g)}
                                className={selectedGallery && selectedGallery._id === g._id ? "active" : ""}
                                >
                                <td>{g._id}</td>
                                <td>{g.name}</td>
                                {/* <td>{g.spaceType}</td> */}
                            </tr>
                        })}
                    </tbody>
                </table>    
            </div>}
            <GalleryFileConfirmModal 
                file={hdriFile}
                batchUpdate={batch}
                gallery={selectedGallery}
                onHide={() => setConfirmModal(false)}
                onSubmitted={onSubmitted}
                show={confirmModal}
                types={galleryType}
            />
            <ToastContainer />
        </div>
    )
}